<template>
  <div :class="wrapperClassNames">
    <div class="form-input" :class="classNames" :data-format="suffixPrefix">
      <label
        class="form-label"
        data-tool-tip="true"
        :for="name + nameSuffix"
        v-show="showLabel"
      >
        <tool-tip v-if="copy" :copy="copy" :title="title"></tool-tip>
        <span v-else>{{ title }}</span>
      </label>
      <input
        :name="name + nameSuffix"
        :id="name + nameSuffix"
        :maxlength="maxLength"
        :value="model"
        :disabled="disabled"
        :pattern="pattern"
        @input="updateModel($event.target.value)"
        v-on:blur="onBlur($event.target.value)"
        v-on:focus="selectAll"
        ref="input"
      />
    </div>
    <span class="error-message" v-if="hasError">{{ errorMessage }}</span>
  </div>
</template>
<!-- TODO - move this into the proper .scss file -->
<style scoped lang="scss">
@import './../../../sass/brcom/tools/_tools.font-size.scss';
@import './../../../sass/brcom/settings/_settings.theme-colors.scss';
@import './../../../sass/brcom/settings/_settings.global.scss';

.error-message {
  @include font-size($global-sans-serif-font-size-xs);
  color: $theme-red-dark;
  line-height: 1.4;
  display: inline-block;
}
</style>

<script>
import toolTip from 'apps/legacy-components/tool-tip'
import eventHub from 'apps/bankrate-events'

//////////////////////////////////////////////////////////////////////////////
//////// @DEPRECATED - Rewrite or clean up for any future use ////////////////
//////////////////////////////////////////////////////////////////////////////

export default {
  components: {
    'tool-tip': toolTip
  },

  props: {
    model: {
      require: true
    },
    name: {
      type: String,
      require: true
    },
    nameSuffix: {
      type: String,
      default: ''
    },
    trackingName: {
      type: String,
      default: ''
    },
    trackingEnabled: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      require: true
    },
    copy: {
      type: Array
    },
    maxLength: {
      type: Number
    },
    minValue: {
      type: Number
    },
    maxValue: {
      type: Number
    },
    suffix: {
      type: String,
      default: ''
    },
    showSuffix: {
      type: Boolean,
      default: true
    },
    prefix: {
      type: String,
      default: ''
    },
    showPrefix: {
      type: Boolean,
      default: true
    },
    error: {
      type: String
    },
    autoValidate: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    allowDecimals: {
      type: Boolean,
      default: true
    },
    hasBottomMargin: {
      type: Boolean,
      default: true
    },
    fireFocus: {
      type: Boolean,
      default: false
    },
    fireBlur: {
      type: Boolean,
      default: false
    },
    format: {
      type: String
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pattern: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      hasError: false,
      lastValue: this.model,
      errorMessage: ''
    }
  },

  created: function() {},

  computed: {
    classNames() {
      return (
        (this.suffix
          ? ' --data-format-right'
          : this.prefix
          ? ' --data-format-left'
          : '') + (this.copy ? ' +pos-relative' : '')
      )
    },
    wrapperClassNames() {
      return this.hasBottomMargin ? ' +mg-bottom' : ''
    },
    suffixPrefix() {
      return this.suffix && this.showSuffix
        ? this.suffix
        : this.prefix && this.showPrefix
        ? this.prefix
        : ''
    },
    fieldName() {
      return this.trackingName
        ? this.trackingName
        : this.name.replace(/([A-Z])/g, ' $1').toLowerCase()
    }
  },

  methods: {
    preventBadInput(e) {
      if (
        (e.which < 48 || e.which > 57) && // digits
        e.which !== 44 &&
        e.which !== 46
      ) {
        // comma, period
        e.preventDefault()
      }
    },

    cleanValue: function(value) {
      if (value !== '') {
        if (this.allowDecimals) {
          value = value.replace(/[^0-9.]/g, '')
          if ((value.match(/\./g) || []).length > 1) {
            value = parseFloat(value)
          }
        } else {
          value = value.replace(/[^0-9]/g, '')
        }
      }
      return value
    },

    formattedValue: function(value) {
      if (
        this.format &&
        typeof this.$options.filters[this.format] === 'function'
      ) {
        return this.$options.filters[this.format](value)
      }
      return Number(value)
    },

    updateModel(value) {
      let cleanedValue = this.cleanValue(value)
      this.displayError(cleanedValue)
      this.$emit(
        'input',
        cleanedValue === '' ? '' : this.formattedValue(cleanedValue)
      )
      this.$emit('value-inputted', this)
      this.$refs.input.value = cleanedValue
    },

    onBlur: function(value) {
      let cleanedValue = this.cleanValue(value)
      if (this.lastValue !== cleanedValue) {
        this.lastValue = cleanedValue

        // add prefix
        cleanedValue = this.prefix + cleanedValue

        // add suffix
        cleanedValue = cleanedValue + this.suffix

        if (this.trackingEnabled) {
          eventHub.$emit('fieldChanged', {
            fieldName: this.fieldName,
            value: cleanedValue.toLowerCase()
          })
        }
      }
      if (this.fireBlur) {
        this.$emit('blur', this)
      }
    },

    hasDisplayError: function() {
      return this.displayError(this.$refs.input.value, true)
    },

    setFocus: function() {
      this.$refs.input.focus()
    },

    displayError: function(value, validate) {
      if (
        (this.autoValidate || validate) &&
        (!this.allowEmpty || value !== '')
      ) {
        let cleanedValue = this.cleanValue(value)
        if (cleanedValue < this.minValue || cleanedValue > this.maxValue) {
          if (!this.$el.firstChild.classList.contains('--has-error')) {
            this.$el.firstChild.classList.add('--has-error')
          }
          this.errorMessage = this.error
          this.hasError = true
          return true
        }
      }

      this.$el.firstChild.classList.remove('--has-error')
      this.hasError = false
      return false
    },

    showDisplayError: function(message) {
      this.errorMessage = message
      this.hasError = true
      if (!this.$el.firstChild.classList.contains('--has-error')) {
        this.$el.firstChild.classList.add('--has-error')
      }
    },

    isBlank: function(message) {
      if (this.$refs.input.value === '' && message !== '') {
        this.$el.firstChild.classList.add('--has-error')
        this.errorMessage = message
        this.hasError = true
        return true
      } else {
        this.$el.firstChild.classList.remove('--has-error')
        this.hasError = false
        return false
      }
    },

    selectAll: function(event) {
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function() {
        event.target.select()
      }, 0)

      // emit focus so parent can trigger onFocus method
      if (this.fireFocus) {
        this.$emit('focus', this)
      }
    }
  }
}
</script>
